import React from 'react';
import './Loader.scss';

const Loader = () => (
  <div className="loader">
    <div className="spinner-border" role="status" />
  </div>
);


export default Loader;
